import { useEffect, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { copyText } from '../kit/clipboard';

const SIZE = { xs: 'btn-xs', sm: 'btn-sm' } as const;

export function CopyButton({ value, label = 'Copy to clipboard', size = 'xs', className = '' }: { value: string; label?: string; size?: keyof typeof SIZE; className?: string }) {
  const [state, setState] = useState<'idle' | 'copied' | 'failed'>('idle');
  useEffect(() => {
    if (state === 'idle') return;
    const t = setTimeout(() => setState('idle'), 1600);
    return () => clearTimeout(t);
  }, [state]);

  return (
    <>
      <button type="button" className={`btn btn-ghost btn-square swap swap-rotate ${state === 'copied' ? 'swap-active' : ''} ${SIZE[size]} ${className}`} aria-label={label} title={label} onClick={async () => setState((await copyText(value)) ? 'copied' : 'failed')}>
        <Copy className="swap-off size-3.5" aria-hidden="true" />
        <Check className="swap-on size-3.5 dr-ink-success" aria-hidden="true" />
      </button>
      <span className="sr-only" aria-live="polite">
        {state === 'copied' ? 'Copied to clipboard' : state === 'failed' ? 'Copy failed; select the text manually' : ''}
      </span>
    </>
  );
}
